import React, {useContext, useEffect} from "react";
import {Link} from 'react-router-dom'
import {useForm, FormProvider} from "react-hook-form";

import Button from '@mui/material/Button';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

import dayjs from 'dayjs';
import 'dayjs/locale/ro';

import * as DataPattern from '../../constants/DataPattern';
import * as AuthorizationInternalFragment from './AuthzInternalFragmentComponent';
import * as CustomStyles from '../../styles/CustomStyles';
import {formatAuthzInternalDates} from './AuthzHelper';
import BucketContext from "../../context/BucketContext";
import * as TypeConvertor from '../../util/TypeConvertor';
import * as ReminderGenInternal from '../../../utils/calculators/ReminderGeneratorInternal';
import * as AFFragment from '../../custom/AFFragment';


const AuthorizationInternalManagement = (props) => {
    console.log('AuthorizationInternalManagement Component___');
    const bucketContext = useContext(BucketContext);

    useEffect(() => {
        if(bucketContext.bucket.mostRecentAuthzId != null) {
            console.log('Reseting the mostRecentAuthzId: ' + JSON.stringify(bucketContext.bucket.mostRecentAuthzId));
            bucketContext.setBucketValue({mostRecentAuthzId: null});
        }
    });

    const methods = useForm({
        defaultValues: {
            lAuthorization: props.authorization,
            employeeId: props.employee.id,
            employerId: props.employee.employmentDetails.employerId,
        } 
    });
    const handleSubmit = methods.handleSubmit;


    const handleSubmitAuthzUpdate = (data, event) => {
        event.preventDefault();
        const authorization = data.lAuthorization;
        formatAuthzInternalDates(authorization);
        const reminder = ReminderGenInternal.generateReminder(authorization, props.employer.preference);
        if(reminder) {
            authorization.reminder = ReminderGenInternal.getAuthzReminder(reminder);
            reminder.extra = ReminderGenInternal.getReminderExtra(props.employee, props.employer, props.worksite);
        }
        else {
            authorization.reminder = {};
        }
        props.saveAuthorization(authorization, reminder);
    }

    const reminderDesc = () => {
        var desc = '';
        if(props.authorization.reminder?.type) {
            const remDt = dayjs(props.authorization.reminder.dataReminder).format(DataPattern.DATE_FORMAT_RO);
            desc =`Reminder: ${remDt}`
        }

        return desc;
    }

    return(
        <Container maxWidth="xl" >
        <Box px={{xs: 3, sm: 7}}>

            <Stack spacing={1} sx={{marginBottom: 2}}>
                <Box>
                    <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                        <Link to={`/employees/${props.employee.id}`}>{props.employee.generalSection.lastName} {props.employee.generalSection.firstName}</Link>
                        <Typography color="text.primary">
                            Autorizatie Interna
                        </Typography>
                    </Breadcrumbs>
                </Box>       

                <Box>
                    <h3>{props.employee.generalSection.lastName} {props.employee.generalSection.firstName} - {TypeConvertor.getAuthzInternalName(props.authorization.autorizatie.authInternal)}</h3>
                </Box>
                <hr/>

                <FormProvider {...methods} > 
                <form id='aaInternalConstructionForm' onSubmit={handleSubmit(handleSubmitAuthzUpdate)}>

                    <AuthorizationInternalFragment.AuthorizationInternal 
                        rsvtiOperators={props.rsvtiOperators}
                        saveAuthzCert={props.saveAuthzCert}
                    />

                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                        {/*row*/}
                        <Grid item xs={12} container justifyContent="flex-end" alignItems="flex-end">
                            <Button variant="outlined" type="submit" sx={{ marginRight: 1}}>Salveaza</Button>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                        {/*row*/}
                        <Grid item xs={3}>
                            <Typography color="text.primary" paddingTop={0} >Reinnoire Adeverinta</Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography color="text.primary" paddingTop={0} >{reminderDesc()}</Typography>
                        </Grid>
                    </Grid>

                    <AFFragment.UpdateDetailsSection entity={props.authorization}/>

                </form>
                </FormProvider>

            </Stack>
        </Box>
        </Container>
    );

}

export default AuthorizationInternalManagement